<template>
  <v-container id="regular-tables" fluid tag="section" style="font-size:10px">
    <base-material-card color="#ed3325" icon="mdi-clipboard-text" title="Listado rutas" class="px-5 py-3">
      <template>
         <v-form>
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field dense label="Ingrese un ODS" outlined v-model="fOds"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field dense label="Ingrese un folio" outlined v-model="fFolio"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field dense label="Ingrese un importe" outlined v-model="fImporte"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select dense label="Estatus" outlined :items="itemsEstatus" v-model="fEst" item-text="value" item-value="id"></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field dense label="Fecha inicio" type="date" outlined v-model="fini"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field dense label="Fecha fin" type="date" outlined v-model="ffin"></v-text-field>
              </v-col>  
              <v-col cols="12" md="10" sm="12">
                <v-btn color="green" @click="getSolicitudes()">Buscar</v-btn>
                <v-btn color="blue" @click="limpiarFiltro()">Limpiar filtros</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-data-table dense :headers="headers" :items="items" :items-per-page="10" :loading="loadingModal" v-if="tipo_id === 1">
          <template v-slot:top>
            <v-toolbar flat >
              <v-spacer></v-spacer>
              <v-btn color="blue" @click="getInfoTable()" fab small title="Actualizar tabla"><v-icon color="white">mdi-refresh</v-icon></v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.estatus`]="{ item }">
              <v-btn
                  x-small
                  :color="estatusColor[item.estatus] || 'grey'"
                  text-color="white"
                  width="150"
                >
                  {{ item.estatusShow }}
                </v-btn>
            </template>
          <template v-slot:[`item.acciones`]="{ item }">
            <v-menu open-on-hover top offset-y v-if="item.estatus !== '0'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="green" x-small dark v-bind="attrs" v-on="on" elevation="2">
                  Opciones
                  <v-icon x-small>mdi-arrow-down-drop-circle-outline</v-icon>
                </v-btn>
              </template>
              <v-list v-if="item.tieneInvalido === 0">
                  <v-list-item>
                      <v-list-item-title>
                          <v-btn class="mx-2" dark small color="blue" width="150" title="Subir PDF/XML" @click="verPDF(item)">
                            <v-icon left dark small>
                              mdi-file
                            </v-icon>
                            Ver solicitud
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="item.estatus === '4'">
                        <v-btn class="mx-2" dark small color="green" title="Subir evidencias" width="150" @click="verPago(item)" >
                          <v-icon left dark>mdi-eye</v-icon>
                            Ver pago
                        </v-btn>
                      </v-list-item>
                    <v-list-item v-if="item.PDF && item.estatus !== '4'">
                      <v-btn class="mx-2" dark small color="green" title="Subir evidencias" width="150" @click="openEvidencias(item)" >
                        <v-icon left dark>mdi-file</v-icon>
                        Subir evidencias
                      </v-btn>
                    </v-list-item>
                    <!--v-list-item v-if="item.estatus === '4'">
                      <v-btn class="mx-2" dark small color="success" title="Subir complemento de pago" width="150" @click="subirComplemento(item)" >
                        <v-icon left dark>mdi-file</v-icon>
                          Subir complemento
                      </v-btn>
                    </v-list-item-->
                    <v-list-item v-if="!item.PDF">
                      <v-list-item-title>
                        <v-btn class="mx-2" dark small color="orange" width="150" title="Subir PDF/XML" @click="openModalXMLPDF(item)" >
                          <v-icon left dark small>
                            mdi-file
                          </v-icon>
                          Subir PDF/XML
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                  <v-list v-else>
                    <v-list-item>
                        <v-btn class="mx-2" dark small color="orange" title="Actualizar archivos" width="180" @click="openModalActualiza(item.listaInvalido, item.id)">
                          <v-icon left dark>mdi-file</v-icon>
                          Actualizar archivos
                        </v-btn>
                      </v-list-item>
                  </v-list>
                </v-menu>
          </template>
        </v-data-table>
        <v-data-table dense :headers="headersN" :items="items" :items-per-page="10" :loading="loadingModal" v-if="tipo_id === 2">
            <template v-slot:top>
              <v-toolbar flat >
                <v-spacer></v-spacer>
                <v-btn color="blue" @click="getInfoTable()" fab small title="Actualizar tabla"><v-icon color="white">mdi-refresh</v-icon></v-btn>
              </v-toolbar>
            </template>
            <template v-slot:[`item.estatus`]="{ item }">
              <v-btn
                  x-small
                  :color="estatusColor[item.estatus] || 'grey'"
                  text-color="white"
                  width="150"
                  :style="item.estatus === '5' ? 'width: 150px;color: white;background-color: #112af9 !important;': ''"
                >
                  {{ item.estatusShow }}
                </v-btn>
            </template>
            <template v-slot:[`item.acciones`]="{ item }">
              <v-menu open-on-hover top offset-y v-if="item.estatus !== '0'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="green" x-small dark v-bind="attrs" v-on="on" elevation="2">
                    Opciones
                    <v-icon x-small>mdi-arrow-down-drop-circle-outline</v-icon>
                  </v-btn>
                </template>
                <v-list v-if="item.tieneInvalido === 0">
                  <v-list-item>
                    <v-list-item-title>
                        <v-btn class="mx-2" dark small color="blue" width="150" title="Subir PDF/XML" @click="verPDF(item)">
                          <v-icon left dark small>
                            mdi-file
                          </v-icon>
                          Ver solicitud
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.estatus === '4'">
                    <v-btn class="mx-2" dark small color="green" title="Subir evidencias" width="150" @click="verFichaPago(item)" >
                      <v-icon left dark>mdi-eye</v-icon>
                        Ver pago
                      </v-btn>
                    </v-list-item>
                  <v-list-item v-if="item.PDF && item.estatus !== '4'">
                    <v-btn class="mx-2" dark small color="green" title="Subir evidencias" width="150" @click="openEvidencias(item)" >
                      <v-icon left dark>mdi-file</v-icon>
                      Subir evidencias
                    </v-btn>
                  </v-list-item>
                  <!--v-list-item v-if="item.estatus === '4'">
                    <v-btn class="mx-2" dark small color="success" title="Subir complemento de pago" width="150" @click="subirComplemento(item)" >
                      <v-icon left dark>mdi-file</v-icon>
                      Subir complemento
                    </v-btn>
                  </v-list-item-->
                  <v-list-item v-if="!item.PDF">
                    <v-list-item-title>
                      <v-btn class="mx-2" dark small color="orange" width="150" title="Subir PDF/XML" @click="openModalXMLPDF(item)" >
                        <v-icon left dark small>
                          mdi-file
                        </v-icon>
                        Subir PDF/XML
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-list v-else>
                  <v-list-item>
                      <v-btn class="mx-2" dark small color="orange" title="Actualizar archivos" width="180" @click="openModalActualiza(item.listaInvalido, item.id)">
                        <v-icon left dark>mdi-file</v-icon>
                        Actualizar archivos
                      </v-btn>
                    </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
      </template>
    </base-material-card>

    <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogEvi" persistent>
            <v-card>
              <v-toolbar color="primary" dark>Subir Evidencias</v-toolbar>
              <v-card-text>
                <br>
                <vue-dropzone ref="evidencias" id="dropzoneEvi" :options="dropzoneOptionsEvidencias" :useCustomSlot=true @vdropzone-complete="validarEvi" method="POST" @vdropzone-sending-multiple="prepareEvi">
                  <h3 class="dropzone-custom-title">Arrastra y suelta tus Archivos</h3>
                  <div class="subtitle">...o haga clic para seleccionar un archivo de su computadora</div>
                </vue-dropzone>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="removeAllFiles()">Cerrar</v-btn>
                <v-btn  @click="enviarEvi()" color="green">Enviar Evidencia</v-btn>
              </v-card-actions>
            </v-card>
    </v-dialog>
    <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogPDFXML" persistent >
              <v-card>
                <v-toolbar color="primary" dark>Subir PDF/XML</v-toolbar>
                <v-card-text>
                  <br>
                  <vue-dropzone ref="xml" id="dropzonexml" :options="dropzoneOptions" :useCustomSlot=true @vdropzone-complete="validarXml" method="POST" @vdropzone-sending-multiple="prepareXML" v-show="!validXml">
                    <h3 class="dropzone-custom-title">Arrastra y suelta tu Archivo XML</h3>
                    <div class="subtitle">...o haga clic para seleccionar el archivo de su computadora</div>
                  </vue-dropzone>

                  <vue-dropzone ref="pdf" id="dropzonepdf" :options="dropzoneOptionsPdf" :useCustomSlot=true @vdropzone-complete="validarPDF" method="POST" @vdropzone-sending-multiple="prepareXML" v-show="validXml">
                      <h3 class="dropzone-custom-title">Arrastra y suelta tu Archivo PDF</h3>
                      <div class="subtitle">...o haga clic para seleccionar el archivo de su computadora</div>
                    </vue-dropzone>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn text @click="closeModalXML()">Cerrar</v-btn>
                  <v-btn  @click="enviarXML()" color="green" v-if="!validXml">Enviar XML</v-btn>
                  <v-btn  @click="enviarPDF()" color="green" v-else>Enviar PDF</v-btn>
                </v-card-actions>
              </v-card>
    </v-dialog>

    <!--Dialog subir complemento-->
    <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogComplemento" persistent>
      <v-card>
        <v-toolbar color="primary" dark>Subir complemento de pago</v-toolbar>
                <v-card-text>
                  <br>
                  <vue-dropzone ref="comp" id="dropzonecomp" :options="dropzoneOptionsComple" :useCustomSlot=true @vdropzone-complete="validarComple" method="POST" @vdropzone-sending-multiple="prepareComple">
                    <h3 class="dropzone-custom-title">Arrastra y suelta tus Archivos</h3>
                    <div class="subtitle">...o haga clic para seleccionar el archivo de su computadora</div>
                  </vue-dropzone>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn text @click="closeModalComple()">Cerrar</v-btn>
                  <v-btn  @click="enviarComple()" color="green">Enviar complemento</v-btn>
                </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPDF" fullscreen hide-overlay transition="dialog-bottom-transition" :loading="true">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogPDF = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Visualizador PDF</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="savePDF()">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
         <iframe :src="urlPDF" title="Cotizacion" :height="height" width="100%" type="application/pdf" />
      </v-card>
    </v-dialog>

    <v-dialog transition="dialog-bottom-transition" max-width="1400" v-model="dialogActualiza">
            <v-card>
              <v-toolbar color="primary" dark >Documentos rechazados</v-toolbar>
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" style="width:200px"> Documento </th>
                        <th class="text-left"> Comentario </th>
                        <th class="text-left"> Origen </th>
                        <th class="text-left"> Carga de archivo </th>
                        <th class="text-left"> Accion </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="it in listaInvalidos" :key="it.id">
                        <td><v-btn text color="blue" class="pull-right" @click="verArchivo(it)"> {{ it.nombre_documento }}  </v-btn></td>
                        <td> {{ it.comentarios }}</td>
                        <td v-if="it.origen == 'PDF'"> PDF Factura</td>
                        <td v-if="it.origen == 'EVI'"> EVIDENCIA </td>
                        <td><v-file-input v-model="it.file" label="Subir actualización" dense></v-file-input> </td>
                        <td><v-btn color="green" small fab @click="updateFile(it.file, it)" :disabled="!it.file" :loading="loadingDoc"><v-icon>mdi-refresh</v-icon></v-btn></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <!--div class="text-h2 pa-12" v-for="it in listaInvalidos" :key="it.id">
                  <v-row>
                    <v-col md="3">
                      <v-btn text color="blue" class="pull-right" @click="verArchivo(it)"> {{ it.nombre_documento }}  </v-btn>
                    </v-col>
                    <v-col md="3">
                      {{ it.comentarios }}
                    </v-col>
                    <v-col md="3">
                      <v-file-input v-model="it.file" label="Subir actualización" dense></v-file-input>
                    </v-col>
                    <v-col md="3">
                      <v-btn color="green" @click="updateFile(it.file, it)" :disabled="!it.file" :loading="loadingDoc">Actualizar</v-btn>
                    </v-col>
                  </v-row>
                </div-->
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialogActualiza = false" color="primary" >Cerrar</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
</v-container>

</template>

<script>
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      dialogEvi: false,
      dialogPDFXML: false,
      dialogActualiza: false,
      listaInvalidos:[],
      validXml: false,
      dialogReg: false,
      menu2: false,
      loadingDoc:false,
      loadingModal:false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      ffin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      items: [],
      headers: [
        {
          text: 'Serie-folio',
          value: 'folio',
        },
        { text: 'Proveedor', value: 'razon_social' },
        { text: 'Estatus', value: 'estatus' },
        { text: 'Ruta', value: 'nombre_ruta' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Importe', value: 'total_display' },
        { text: 'Factura', value: 'num_factura' },
        { text: 'Pago', value: 'pago' },
        //{text: 'Fecha Compromiso', value: 'fecha_compromiso'},
        { text: 'Acciones', value: 'acciones' },
      ],
      headersN: [
        {
          text: 'Serie-folio',
          value: 'folio',
        },
        { text: 'Proveedor', value: 'razon_social' },
        { text: 'Estatus', value: 'estatus' },
        //{ text: 'Ruta', value: 'nombre_ruta' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Importe', value: 'total_display' },
        { text: 'Factura', value: 'num_factura' },
        { text: 'Pago', value: 'pago' },
        {text: 'Fecha Compromiso', value: 'fecha_compromiso'},
        { text: 'Acciones', value: 'acciones' },
      ],
      fEst: '',
      fOds:'',
      fFolio:'',
      fImporte:'',
      itemsEstatus: [
        { id: 0, value: 'Cancelado' },
        { id: 1, value: 'Proceso' },
        { id: 2, value: 'CXC' },
        { id: 3, value: 'CXP' },
        { id: 4, value: 'Pagado' }
      ],
      dropzoneOptions: {
        url: axios.defaults.baseURL+'/proveedores/readxml',
        thumbnailWidth: 1,
        maxFilesize: 1.5,
        maxFiles: 1,
        addRemoveLinks: true,
        uploadMultiple: true,
        autoProcessQueue: false,
        acceptedFiles: ".xml"
      },
      dropzoneOptionsEvidencias: {
        url: axios.defaults.baseURL + '/proveedores/saveEvidencias',
        thumbnailWidth: 1,
        maxFilesize: 1.5,
        addRemoveLinks: true,
        uploadMultiple: true,
        autoProcessQueue: false,
        autoProcessQueue: false
      },
      dropzoneOptionsPdf: {
        url: axios.defaults.baseURL + '/proveedores/savePDF',
        thumbnailWidth: 1,
        maxFilesize: 1.5,
        maxFiles: 1,
        acceptedFiles: ".pdf",
        addRemoveLinks: true,
        uploadMultiple: true,
        autoProcessQueue: false
      },
      dropzoneOptionsComple: {
        url: axios.defaults.baseURL+'/solicitud/subirComplemento',
        thumbnailWidth: 1,
        maxFilesize: 1.5,
        maxFiles: 2,
        addRemoveLinks: true,
        uploadMultiple: true,
        autoProcessQueue: false,
      },
      serie_select: '',
      viaje: {
        id: localStorage.getItem('id') ? localStorage.getItem('id') : 0,
        proveedor_id: localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0,
        razon_s: '',
        rfc: localStorage.getItem('rfc') ? localStorage.getItem('rfc') : '',
        direccion:'',
        tipo: (Number(localStorage.getItem('tipo_id')) === 1) ? 'Permisionario' : 'Proveedor',
        tipo_id: Number(localStorage.getItem('tipo_id')),
        operador: 0,
        ruta_id: '',
        camion: 0,
        importe: 0.0,
        fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dias_c: 0,
        comentarios:''
      },
      rutas: [],
      itemSerie: {
        id: '',
        folio:'',
        estatus: '',
        ruta: '',
        fecha: '',
        importe: '',
        validacion: false
      },
      dialogPDF: false,
      urlPDF: '',
      height: 0,
      tipo_id:1,
      selectedSolicitud:'',
      dialogComplemento:false,
      estatusColor: {
        0: 'red',
        1: 'default',
        2: 'purple',
        3: 'blue',
        4: 'green',
        5: 'green'
      }
    }
  },
  created() {
    const id_p = localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0
    this.getInfoProveedor(id_p)
    this.getRutas()
    this.getSolicitudes()
    this.height = window.innerHeight - 70
    this.tipo_id = Number(localStorage.getItem('tipo_id')) ? Number(localStorage.getItem('tipo_id')) : 1
  },
  methods: {
    deleteItem(id) {
      this.$swal({
        title: '¿Estas seguro de eliminar el registro?',
        icon: 'info',
        showConfirmButton:false,
        showDenyButton: true,
        showCancelButton: true,
        denyButtonText:'Eliminar',
        cancelButtonText:'Cancelar',
      });
    },
    removeAllFiles() {
      this.$refs.evidencias.removeAllFiles()
      this.dialogEvi = false
    },
    openModalXMLPDF(serie) {
      this.loadingModal = true
      this.getValidXml(serie)
    },
    openEvidencias(serie) {
      this.dialogEvi = true
      this.itemSerie = serie
    },
    openModalComple(item){
      this.itemSerie = item
      this.dialogComplemento = true
    },
    closeModalXML() {
      this.dialogPDFXML = false
      if (this.validXml) {
        this.$refs.pdf.removeAllFiles()
      } else {
        this.$refs.xml.removeAllFiles()
      }
      this.validXml = false
    },
    closeModalComple(){
      this.dialogComplemento = false
      this.$refs.comp.removeAllFiles()
    },
    enviarComple(){
      this.$refs.comp.processQueue()
    },
    validarXml: async function (response) {
      const json = JSON.parse(response.xhr.response)
      //console.log(response)
      if (response.status == 'success') {
        if (json.success) {
          this.validXml = true
          this.itemSerie.validacion = true
        }
        this.alertMensaje(json.mensaje)
      } else {
        this.alertMensajeError(json.mensaje)
      }
    },
    validarPDF: async function (response) {
      if (response.status == 'success') {
        const json = JSON.parse(response.xhr.response)
        this.getSolicitudes()
        this.alertMensaje(json.mensaje)
        this.closeModalXML()
      }
    },
    validarEvi: async function (response) {
      if (response.status == 'success') {
        const json = JSON.parse(response.xhr.response)
        this.getSolicitudes()
        this.alertMensaje(json.mensaje)
      }
    },
    validarComple: async function(response){
      if (response.status == 'success') {
        const json = JSON.parse(response.xhr.response)
        this.alertMensaje(json.mensaje)
      }
    },
    alertMensaje(mensaje) {
      this.$swal({
        position: 'top-end',
        icon: 'success',
        title: mensaje,
        showConfirmButton: true,
        timer: 5000,
        backdrop:null
      });
    },
    alertMensajeError(mensaje) {
      this.$swal({
        position: 'top-end',
        icon: 'warning',
        title: mensaje,
        mensaje:'Verifique su informacion',
        showConfirmButton: true,
        //timer: 4000,
        backdrop: null
      });
    },
    enviarXML() {
      this.$refs.xml.processQueue()
    },
    enviarPDF() {
      this.$refs.pdf.processQueue()
    },
    enviarEvi() {
      this.$refs.evidencias.processQueue()
    },
    prepareXML: async function (files, xhr, formData) {
      const id_p = localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0
      const tipo = localStorage.getItem('tipo_id')
      const id = localStorage.getItem('id')
      formData.append('id_usuario', id)
      formData.append('serie', this.itemSerie.id)
      formData.append('folio', this.itemSerie.folio)
      formData.append('importe', this.itemSerie.importe_double)
      formData.append('tipo_id', tipo)
      formData.append('proveedor_id', id_p)
    },
    preparePDF: async function (files, xhr, formData) {
      const id_p = localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0
      const tipo = localStorage.getItem('tipo_id')
      const id = localStorage.getItem('id')
      formData.append('id_usuario', id)
      formData.append('serie', this.itemSerie.id)
      formData.append('folio', this.itemSerie.folio)
      formData.append('tipo_id', tipo)
      formData.append('proveedor_id', id_p)
    },
    prepareEvi: async function (files, xhr, formData) {
      const id_p = localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0
      const tipo = localStorage.getItem('tipo_id')
      const id = localStorage.getItem('id')
      formData.append('id_usuario', id)
      formData.append('serie', this.itemSerie.id)
      formData.append('folio', this.itemSerie.folio)
      formData.append('tipo_id', tipo)
      formData.append('proveedor_id', id_p)
    },
    prepareComple: async function (files, xhr, formData) {
      const id_p = localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0
      const tipo = localStorage.getItem('tipo_id')
      const id = localStorage.getItem('id')
      formData.append('id_usuario', id)
      formData.append('serie', this.itemSerie.id)
      formData.append('folio', this.itemSerie.folio)
      formData.append('importe', this.itemSerie.importe_double)
      formData.append('tipo_id', tipo)
      formData.append('proveedor_id', id_p)
    },
    closeModalReg() {
      this.dialogReg = false
    },
    openModalReg() {
      this.dialogReg = true
      this.viaje.operador = ''
      this.viaje.ruta_id = ''
      this.viaje.camion = ''
      this.viaje.importe = 0.0
      this.viaje.fecha = ''
      this.viaje.comentarios = ''
    },
    getInfoProveedor(id) {
      axios.get('/proveedor/' + id).then(resp => {
        const { data } = resp
        const datos_p = data.data

        this.viaje.razon_s = datos_p.razon_social
        this.viaje.direccion = datos_p.direccion
        this.viaje.dias_c = datos_p.diascredito

      })
    },
    getRutas() {
      axios.get('/rutas').then(resp => {
        //console.log(resp)
        this.rutas = resp.data.data
      })
    },
    async getSolicitudes() {
      this.items = []
      this.loadingModal = true
      const id_p = localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0
      await axios.get('/solicitudes/'+ id_p+'?es='+this.fEst+'&folio='+this.fFolio+'&imp='+this.fImporte+'&fini='+this.fini+'&ffin='+this.ffin).then(resp => {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
        const { data } = resp
        data.forEach(element => {
          element.proceso = 10
          element.importe_double = Number(element.importe) + Number(element.otr_ingresos)
          element.importe = element.importe
          const td = Number(element.importe) + Number(element.otr_ingresos)
          element.total_display = formatter.format(td)
          //console.log(element.importe_double)
          const estatusMap = {
            0: 'Cancelado',
            1: 'Proceso',
            2: 'CXC',
            3: 'CXP',
            4: 'Pagado',
            5: 'Pagado - CP'
          };

          element.estatusShow = estatusMap[Number(element.estatus)] ?? 'Desconocido';

          if (Number(element.tieneInvalido) > 0){
            element.estatusShow = 'Rechazado'
          }
        });
        this.items = data
        this.loadingModal = false
      })
    },
    async getInvalidos(id) {
      await axios.get('invalidos/'+id).then(resp => {
        const { data } = resp
        this.listaInvalidos = data
        if (data.lenght === 0) {
          this.dialogActualiza = false
        }
      })
    },
    async verPDF(item) {
      this.urlPDF = ''
      this.dialogPDF = true
      await axios.post('/solicitud/pdf', { id: item.id }, { responseType: 'blob' }).then(resp => {
        const blob = new Blob([resp.data], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(blob);
        this.urlPDF = objectUrl
      })
    },
    savePDF() {

    },
    async getValidXml(serie) {
      await axios.post('/proveedores/validXML', {serie: serie.id}).then(resp => {
        const { data } = resp
        if (data.data.PDF) {
          this.loadingModal = false
          this.alertMensaje('Los documentos se estan validando')
          return
        }
        this.dialogPDFXML = true
        this.itemSerie = serie
        if (this.validXml) {
          if (this.$refs.xml) {
            this.$refs.pdf.removeAllFiles()
          }
        } else {
          if (this.$refs.xml) {
            this.$refs.xml.removeAllFiles()
          }
        }
        this.validXml = data.data.XML
        this.loadingModal = false
      })
    },
    getInfoTable() {
      this.getSolicitudes()
    },
    async verPago(item) {
      this.urlPDF = ''
      await axios.post('/solicitud/pago', { serie: item.id }).then(resp => {
        const { data } = resp
        switch (data.data.tipo_documento.toLowerCase()) {
          case 'png':
            this.dialogPDF = true
            this.urlPDF = 'data:image/png;base64,' + data.data.base_64
            break;

          case 'pdf':
            this.dialogPDF = true
            this.urlPDF = 'data:application/pdf;base64,' + data.data.base_64
            break;

          case 'xml':
            this.dialogPDF = true
            this.urlPDF = 'data:text/xmldata;base64,' + data.data.base_64
            break;

          case 'jpg':
            this.dialogPDF = true
            this.urlPDF = 'data:image/jpg;base64,' + data.data.base_64
            break;

          case 'jpeg':
            this.dialogPDF = true
            this.urlPDF = 'data:image/jpeg;base64,' + data.data.base_64
            break;

          case 'jfif':
            this.dialogPDF = true
            this.urlPDF = 'data:image/jfif;base64,' + data.data.base_64
            break;

          default:
            break;
        }
      })
    },
    async verFichaPago(item) {
      this.loadingModal = true
      try {
        await axios.post('/solicitud/verFichaPago', item).then( resp => {
          const { data } = resp
          this.dialogPDF = true
          this.urlPDF = 'data:application/pdf;base64,' + data
          this.loadingModal = false
        })
      } catch (e){
        this.loadingModal = false
      }
    },
    limpiarFiltro() {
      this.fEst= ''
      this.fOds= ''
      this.fFolio= ''
      this.fImporte = ''
      this.getSolicitudes()
    },
    openModalActualiza(item, serie) {
      this.getInvalidos(serie)
      this.dialogActualiza = true
    },
    verArchivo(item) {
      switch (item.tipo_documento.toLowerCase()) {
        case 'png':
          this.dialogPDF = true
          this.urlPDF = 'data:image/png;base64,' + item.base_64
          break;

        case 'pdf':
          this.dialogPDF = true
          this.urlPDF = 'data:application/pdf;base64,' + item.base_64
          break;

        case 'xml':
          this.dialogPDF = true
          this.urlPDF = 'data:text/xmldata;base64,' + item.base_64
          break;

        case 'jpg':
          this.dialogPDF = true
          this.urlPDF = 'data:image/jpg;base64,' + item.base_64
          break;

        case 'jpeg':
          this.dialogPDF = true
          this.urlPDF = 'data:image/jpeg;base64,' + item.base_64
          break;

        case 'jfif':
          this.dialogPDF = true
          this.urlPDF = 'data:image/jfif;base64,' + item.base_64
          break;

        default:
          break;
      }
    },
    async updateFile(file, it) {
      this.loadingDoc = true
      const formData = new FormData()

      formData.append('file', file)
      formData.append('id', it.id)
      formData.append('nombre_doc', it.nombre_documento)
      formData.append('origen', it.origen)
      formData.append('serie', it.serie)
      formData.append('tipo_id', this.tipo_id)
      try {
        await axios.post('/proveedores/rechazadoUpdate', formData).then(resp => {
          const { data } = resp 
          if (data.success) {
            this.getInvalidos(it.serie)
            this.alertMensaje(resp.data.mensaje)
          } else {
            this.alertMensajeError(resp.data.mensaje)
          }
          this.getSolicitudes()
          this.loadingDoc = false
        })
      } catch (err) {
        this.loadingDoc = false
      }
    },
    subirComplemento(item){
      this.openModalComple(item)
    }
  },
}
</script>

<style>

</style>
